import React from 'react'
import { Modal, Descriptions, Tag, Typography, Button, Space } from 'antd'
import moment from 'moment-timezone'

const { Text, Paragraph } = Typography

const STATUS_COLORS = {
  waiting: 'blue',
  active: 'green',
  completed: 'default',
  failed: 'red',
  delayed: 'orange',
}

const JobDetail = ({ job, visible, onClose, onRetry, timezone, use24h }) => {
  if (!job) return null

  const fmt = use24h ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD h:mm:ss A'
  const formatTs = (val) => val ? moment(val).tz(timezone).format(fmt) : '-'

  return (
    <Modal
      title={`Job: ${job.name}`}
      open={visible}
      onCancel={onClose}
      width={700}
      footer={
        <Space>
          {job.status === 'failed' && (
            <Button type="primary" onClick={() => onRetry(job.id)}>
              Retry Job
            </Button>
          )}
          <Button onClick={onClose}>Close</Button>
        </Space>
      }
    >
      <Descriptions column={2} bordered size="small">
        <Descriptions.Item label="ID">{job.id}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={STATUS_COLORS[job.status]}>{job.status}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Attempts">{job.attemptsMade}</Descriptions.Item>
        <Descriptions.Item label="Created">
          {formatTs(job.timestamp)}
        </Descriptions.Item>
        <Descriptions.Item label="Processed">
          {formatTs(job.processedOn)}
        </Descriptions.Item>
        <Descriptions.Item label="Finished">
          {formatTs(job.finishedOn)}
        </Descriptions.Item>
      </Descriptions>

      {job.failedReason && (
        <div style={{ marginTop: 16 }}>
          <Text strong>Error:</Text>
          <Paragraph type="danger" style={{ marginTop: 4 }}>
            {job.failedReason}
          </Paragraph>
        </div>
      )}

      {job.stacktrace && job.stacktrace.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Text strong>Stack Trace:</Text>
          <pre style={{
            background: '#f5f5f5',
            padding: 12,
            borderRadius: 4,
            maxHeight: 200,
            overflow: 'auto',
            fontSize: 12,
            marginTop: 4,
          }}>
            {job.stacktrace.join('\n')}
          </pre>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <Text strong>Job Data:</Text>
        <pre style={{
          background: '#f5f5f5',
          padding: 12,
          borderRadius: 4,
          maxHeight: 300,
          overflow: 'auto',
          fontSize: 12,
          marginTop: 4,
        }}>
          {JSON.stringify(job.data, null, 2)}
        </pre>
      </div>
    </Modal>
  )
}

export default JobDetail
